/**
 * Public contact points surfaced in the client (login "Contact us", etc.).
 *
 * ONE place on purpose — when a real support@ inbox exists, change it here
 * and every surface follows. This address ships in the public bundle, so it
 * must be an inbox that is actually read (noreply@ would be a dead end).
 */
export const CONTACT_EMAIL = 'support@crewvex.com';

export const CONTACT_MAILTO = `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent('CrewVex')}`;
